import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from 'ziggy-js';
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';

const appName = 'AlloSlot';

//createInertiaApp({
//    title: (title) => `${title} - ${appName}`,
//    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
//    setup({ el, App, props, plugin }) {
//        return createApp({ render: () => h(App, props) })
//            .use(plugin)
//            .use(ZiggyVue)
//            .mount(el);
//    },
//});

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue)
            .use(FloatingVue);

        // Global translation helper
        // Uses the 'translations' object shared via HandleInertiaRequests.php
        // Supports {token} interpolation: $t('hello', { name: 'World' }) → 'Hello, World!'
        app.config.globalProperties.$t = (key, replacements = {}) => {
            let value = props.initialPage.props.translations[key] || key;
            for (const [token, replacement] of Object.entries(replacements)) {
                value = value.replaceAll('{' + token + '}', replacement);
            }
            return value;
        };

        return app.mount(el);
    },
});